import type {ContextTemplateResponseBody} from '@dms/api/core';
import {plainTextToEmailHtml} from '@dms/shared';

import type {FinancingEndingEditableEmailFormValues} from './FinancingEndingEditableEmailFormSchema';

const LINE_BREAK_TAG_REGEX = /<br\s*\/?>(?:\r\n|\r|\n)?/gi;

// A stored plain-text template may mark its line breaks with `<br/>`; those become new lines and every
// other character stays escaped. A body that comes out unchanged is editor markup, or text that only
// looks like it once a leading `<br/>` is gone: it gets the plain conversion of what is stored.
const templateBodyToEditableHtml = (body: string) => {
  const withLineBreaks = body.replace(LINE_BREAK_TAG_REGEX, '\n');
  const converted = plainTextToEmailHtml(withLineBreaks);

  return converted === withLineBreaks ? plainTextToEmailHtml(body) : converted;
};

/**
 * The editable source a template prefills: its subject and body as stored, placeholders kept. Nothing
 * is rendered for a recipient. A plain-text body becomes one paragraph per line, a `<br/>` counting as
 * a line; a body that already holds editor markup is kept as it is.
 */
export const getFinancingEndingTemplateMessage = (
  template: ContextTemplateResponseBody
): Omit<FinancingEndingEditableEmailFormValues, 'emailCredentialsId'> => ({
  subject: template.subject ?? '',
  body: templateBodyToEditableHtml(template.body),
  templateId: template.id,
  locale: template.locale ?? undefined,
});
